<script lang="ts">
  import type { Snippet } from "svelte";
  import { reportComponentError } from "$lib/errorHandling/errorReporter";
  import ErrorBoundaryFallback from "$lib/errorHandling/ErrorBoundaryFallback.svelte";

  interface Props {
    children: Snippet<[any?]>;
  }
  const { children }: Props = $props();
</script>

<svelte:boundary onerror={reportComponentError}>
  {@render children()}
  {#snippet failed(error: any, _reset)}
    <ErrorBoundaryFallback {error} />
  {/snippet}
</svelte:boundary>
